import { GlButton, GlLoadingIcon, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'SidebarEditableItem',
    i18n: {
        unassigned: __('Unassigned')
    },
    components: {
        GlButton,
        GlLoadingIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        canUpdate: {},
        isClassicSidebar: {
            default: false
        }
    },
    props: {
        buttonId: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        initialLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        isDirty: {
            type: Boolean,
            required: false,
            default: false
        },
        tracking: {
            type: Object,
            required: false,
            default: ()=>({
                    event: null,
                    label: null,
                    property: null
                })
        },
        canEdit: {
            type: Boolean,
            required: false,
            default: true
        },
        editTooltip: {
            type: String,
            required: false,
            default: ''
        },
        editAriaLabel: {
            type: String,
            required: false,
            default: ''
        },
        editKeyshortcuts: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'close',
        'open'
    ],
    data () {
        return {
            edit: false
        };
    },
    computed: {
        editButtonText () {
            return this.isDirty ? __('Apply') : __('Edit');
        },
        editTooltipText () {
            return this.isDirty ? '' : this.editTooltip;
        },
        editAriaLabelText () {
            return this.isDirty ? this.editButtonText : this.editAriaLabel;
        },
        editKeyshortcutsText () {
            return this.isDirty ? __('Escape') : this.editKeyshortcuts;
        }
    },
    destroyed () {
        window.removeEventListener('click', this.collapseWhenOffClick);
        window.removeEventListener('keyup', this.collapseOnEscape);
    },
    methods: {
        collapseWhenOffClick ({ target }) {
            if (!this.$el.contains(target)) {
                this.collapse();
            }
        },
        collapseOnEscape ({ key }) {
            if (key === 'Escape') {
                this.collapse();
            }
        },
        expand () {
            if (this.edit) {
                return;
            }
            if (this.canEdit && this.canUpdate) {
                this.edit = true;
            }
            this.$emit('open');
            window.addEventListener('click', this.collapseWhenOffClick);
            window.addEventListener('keyup', this.collapseOnEscape);
        },
        collapse ({ emitEvent = true } = {}) {
            if (!this.edit) {
                return;
            }
            this.edit = false;
            if (emitEvent) {
                this.$emit('close');
            }
            window.removeEventListener('click', this.collapseWhenOffClick);
            window.removeEventListener('keyup', this.collapseOnEscape);
        },
        toggle ({ emitEvent = true } = {}) {
            if (this.edit) {
                this.collapse({
                    emitEvent
                });
            } else {
                this.expand();
            }
        }
    }
};
